<template>
    <app-layout title="Instellingen">
        <template #header>
            <page-title title="Profiel" />
        </template>

        <template #pageContent>
            <div>
                <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                    <div v-if="this.$page.props.user.roles.includes('it') || this.$page.props.user.roles.includes('admin')">
                        <Route :settings="settings" />

                        <jet-section-border />
                    </div>

                    <div v-if="this.$page.props.user.roles.includes('it') || this.$page.props.user.roles.includes('admin')
                        || this.$page.props.user.permissions.includes('settings.notifications')">
                        <Notifications :notifications="notifications" :subscribed="subscribed" />

                        <jet-section-border />
                    </div>
                </div>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import JetSectionBorder from '@/Jetstream/SectionBorder.vue'
import Notifications from '@/Pages/Settings/Partials/Notifications.vue'
import Route from '@/Pages/Settings/Partials/Route.vue'


export default {
    components: {
        AppLayout,
        PageTitle,
        JetSectionBorder,
        Notifications,
        Route,
    },
    props:[
        'notifications',
        'settings',
        'subscribed'
    ],
}
</script>
